import * as firebase from 'firebase/app'
import 'firebase/database'
import * as DB from '../../database'

export default {
  namespaced: true,

  state: {
    userId: null,
    isWaiting: false,
    onPeerFound: null,
    waitingQueueChangedHandlerRef: null
  },

  mutations: {
    setUserId (state, { userId }) {
      global.DEBUG && console.log('setUserId: ' + userId)
      state.userId = userId
    },

    setIsWaiting (state, { isWaiting }) {
      state.isWaiting = isWaiting
    },

    setOnPeerFound (state, { onPeerFound }) {
      state.onPeerFound = onPeerFound
    },

    setWaitingQueueChangedHandlerRef (state, { waitingQueueChangedHandlerRef }) {
      state.waitingQueueChangedHandlerRef = waitingQueueChangedHandlerRef
    }
  },

  actions: {
    async start ({ state, commit, dispatch }, { userId, onPeerFound }) {
      global.DEBUG && console.log('start waiting')
      commit('setUserId', { userId: userId })
      commit('setOnPeerFound', { onPeerFound: onPeerFound })

      // start listending for changes in the waiting queue
      let waitingQueueChangedHandlerRef = firebase.database().ref(DB.WAITING_USERS).orderByValue().on('value', snapshot => {
        dispatch('waitingQueueChangedHandler', { waitingQueue: snapshot.val() })
      })
      commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: waitingQueueChangedHandlerRef })

      // Enter the waiting queue
      await firebase.database().ref(String.format(DB.WAITING_USER, state.userId)).set(firebase.database.ServerValue.TIMESTAMP)
      commit('setIsWaiting', { isWaiting: true })
    },

    async stop ({ state, commit }) {
      if (state.isWaiting === false) {
        return
      }

      global.DEBUG && console.log('stop waiting')

      // stop listending for changes in the waiting queue
      firebase.database().ref(DB.WAITING_USERS).orderByValue().off('value', state.waitingQueueChangedHandlerRef)
      commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: null })

      // Leave the waiting queue
      await firebase.database().ref(String.format(DB.WAITING_USER, state.userId)).remove()
      commit('setIsWaiting', { isWaiting: false })
    },

    async waitingQueueChangedHandler ({ state, commit }, { waitingQueue }) {
      if (waitingQueue === null) {
        return
      }

      global.DEBUG && console.log('waiting queue:')
      let sortedList = Object.entries(waitingQueue).sort((a, b) => a[1] - b[1])
      var sortedListLenght = sortedList.length
      for (var i = 0; i < sortedListLenght; i++) {
        let item = sortedList[i]
        global.DEBUG && console.log(`  index=${i}, key=${item[0]}, value=${item[1]}`)

        if (item[0] === state.userId && i > 0) { // If we found ourselves in the list...
          // stop listending for changes in the waiting queue
          firebase.database().ref(DB.WAITING_USERS).orderByValue().off('value', state.waitingQueueChangedHandlerRef)
          commit('setWaitingQueueChangedHandlerRef', { waitingQueueChangedHandlerRef: null })

          if ((i % 2) === 1) {
            let remoteId = sortedList[i - 1][0]

            // Remove the two users from the waiting queue
            let updates = {}
            updates[String.format(DB.WAITING_USER, state.userId)] = null
            updates[String.format(DB.WAITING_USER, remoteId)] = null
            await firebase.database().ref().update(updates)
            commit('setIsWaiting', { isWaiting: false })

            // Notify the parent object
            if (state.onPeerFound !== null) {
              state.onPeerFound({ remoteId: remoteId })
            }
          }

          return
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/waitingQueue/index.js